import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from './Select';
import { DEFAULT_SELECT_PLACEHOLDER } from '../../../../config/constants';
import { clearCountries, getCountries } from '../../../../actions';
import { optionsPropTypes } from './SelectPropTypes';

class CountrySelect extends Component {
  componentWillUnmount() {
    const { dispatchClearCountries } = this.props;
    dispatchClearCountries();
  }

  handleInputChange = (inputValue) => {
    const { dispatchGetCountries } = this.props;
    if (inputValue.trim().length && inputValue.trim().length >= 4) {
      dispatchGetCountries({ query: inputValue });
    }
  };

  render() {
    const {
      loading,
      options,
      isGridVariant,
      value,
      isMulti,
      isClearable,
      onValueChange,
      placeholder,
      ...rest
    } = this.props;
    return (
      <Select
        isLoading={loading}
        options={options}
        isMulti={isMulti}
        input={{ value }}
        onValueChange={onValueChange}
        isClearable={isClearable}
        isGridVariant={isGridVariant}
        onInputChange={this.handleInputChange}
        placeholder={placeholder}
        {...rest}
      />
    );
  }
}

CountrySelect.propTypes = {
  isGridVariant: PropTypes.bool,
  options: optionsPropTypes.isRequired,
  loading: PropTypes.bool.isRequired,
  noOptionsMessage: PropTypes.func,
  dispatchGetCountries: PropTypes.func.isRequired,
  dispatchClearCountries: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  onValueChange: PropTypes.func,
  isMulti: PropTypes.bool,
  isClearable: PropTypes.bool,
  placeholder: PropTypes.string,
  value: PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  }),
};

CountrySelect.defaultProps = {
  noOptionsMessage: undefined,
  isDisabled: false,
  isGridVariant: false,
  onValueChange: undefined,
  isClearable: false,
  value: {},
  isMulti: false,
  placeholder: DEFAULT_SELECT_PLACEHOLDER,
};

const mapStateToProps = ({ LocationUnit }) => ({
  options: LocationUnit.Country.getIn(['all', 'content', 'content']).map(
    (country) => ({
      value: country.countryCode,
      label: country.name,
    }),
  ),
  loading: LocationUnit.Country.getIn(['all', 'loading']),
});

const mapDispatchToProps = {
  dispatchGetCountries: getCountries,
  dispatchClearCountries: clearCountries,
};

export default connect(mapStateToProps, mapDispatchToProps)(CountrySelect);
